import { inject } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { isDefined } from "@recursyve/nice-ts-utils";

import { environment } from "../../../environments/environment";

export const installPageGuard: CanActivateFn = () => {
    const storeInstallUrl = environment.storeInstallUrl;
    if (!isDefined(storeInstallUrl)) {
        return inject(Router).createUrlTree(["/login"]);
    }
    return true;
};
